<template>
  <div :class="[$attrs.class, 'tw-mb-4 tw-py-8 tw-pl-8 tw-pr-24 tw-bg-green-500 tw-rounded-3xl tw-relative', flashClass]">
    <h3 class="tw-text-3xl tw-font-black">
      {{message.headline}}
    </h3>
    <p>{{message.text}}</p>
    <button class="tw-absolute tw-top-8 tw-right-8 tw-text-5xl tw-leading-7" @click="handleClick" v-if="!isolated">
      &times;
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'  
import type {PropType} from 'vue';
import type FlashMessage from '../types/FlashMessage';

const props = defineProps({
  message: {
    type: (Object as PropType<FlashMessage>),
    default: null,
  },
  isolated: {
    type: Boolean,
    default: false,
  }
})

const emit = defineEmits(['dismissAlert'])

const handleClick = (event: Event) => {
  emit('dismissAlert', props.message.id)
}

const flashClass = computed(() => {
  if (props.message != null && props.message.messageType == 'success') {
    return 'tw-text-white tw-bg-green-500'
  } else if (props.message.messageType == 'danger') {
    return 'tw-text-white tw-bg-red-500'
  } else {
    return ''
  }
})

</script>